import { PATH_PRIVATE_HOME } from 'tracker.routes';

export default function getStatusPath(packageId) {
  return PATH_PRIVATE_HOME.replace(':packageId', packageId);
}
